import React, { useEffect } from 'react'
import { Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import Dialog from '../../../common/Dialog'
import $t from '../../../../i18n'
import Actions from '../../../../actions'

import './AppDownloadConfirmationDialog.css'

const AppDownloadConfirmationDialog = props => {
  const {
    isDownloadLinkSentLoading,
    isDownloadLinkSentFailure,
    downloadLinkSentErrorMessage,
    isAppDownloadLinkPopUpVisible,
    isDownloadLinkSentSuccess,
  } = useSelector(state => state.app)

  const dispatch = useDispatch()

  const handleOk = () => {
    dispatch(Actions.createAction(Actions.DOWNLOAD_LINK_REQUESTED_THROUGH_SMS))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.DOWNLOAD_LINK_REQUESTED_THROUGH_SMS + '_WEB',
      })
    )
  }

  const onCancel = () => {
    dispatch(Actions.createAction(Actions.CLOSE_APP_DOWNLOAD_LINK_POP_UP))
  }

  useEffect(() => {
    if (isDownloadLinkSentSuccess) {
      dispatch(Actions.createAction(Actions.CLOSE_APP_DOWNLOAD_LINK_POP_UP))
    }
  }, [isDownloadLinkSentSuccess])

  const dialogActions = [
    <Button
      key="1"
      className="dialog-action"
      type="primary"
      onClick={handleOk}
      loading={isDownloadLinkSentLoading}
    >
      {$t('common.ok')}
    </Button>,
  ]

  return (
    <Dialog
      title={$t('pages.getStarted.validIp.downloadLinkTitle')}
      isVisible={isAppDownloadLinkPopUpVisible}
      onCancel={onCancel}
      footerActions={dialogActions}
      className="download-mobile-dialog"
    >
      <div className="error-message">
        {isDownloadLinkSentFailure ? downloadLinkSentErrorMessage : null}
      </div>
    </Dialog>
  )
}

export default AppDownloadConfirmationDialog
